/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "出会いと交流のハブ",
      "Bumble For Friendsアプリで新しい友達をみつけよう｜Bumble",
      "App Storeでダウンロード",
      "Google Playで入手",
      "新しい友達と出会うためのスペース",
      "周辺地域で特別なつながりを探している人々と出会いましょう。",
      "人生のどのステージにいても、友達を探そう",
      "引っ越してきたばかり？新しいスタートを切りたい？一緒に楽しめるお相手があなたを待っています！",
      "すべてのユーザーに安全なスペース",
      "自分らしくいられるインターネットスペースをどうぞお楽しみください。",
      "アプリをダウンロード",
      "趣味や関心が共通する人たちと対面で会おう！",
      "Bumble For FriendsのPlansで新しいグループと出会おう",
      "Plansに招待されています",
      "Bumble For Friendsの新機能「Plans」では、周辺の新しい友達とのオフ会を企画して、参加できます。",
      "Cookieの管理",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "日"
            ],
            "singular": [
                  "日"
            ]
      },
      "hour": {
            "plural": [
                  "時間"
            ],
            "singular": [
                  "時間"
            ]
      },
      "minute": {
            "plural": [
                  "分"
            ],
            "singular": [
                  "分"
            ]
      },
      "month": {
            "plural": [
                  "ヶ月"
            ],
            "singular": [
                  "ヶ月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
